  import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import AppConnector from '../../AppConnector'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash,faPlusCircle,faEdit,faSearch} from '@fortawesome/free-solid-svg-icons'
import {Container,Row,Col } from 'reactstrap';

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    this.GS = new GlobalStorage();
    this.connector = new AppConnector();
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render()
  { 
    var t= this;
    if (global.DEBUG) console.log(this.GS.getUserEpisodeList())
    return (
      <div className="bg-light">
        <Container>
          <Row>
            <Col>
              <h2 className="mt-3">故事章節</h2>
            </Col>
          </Row>
          <Row>
            <Col md="3" className="align-self-center text-center">                 
              <span className="btn m-0 p-0">
                <FontAwesomeIcon icon={faPlusCircle} className="fa-3x" title="新增" onClick={()=>{
                  this.GS.getStoryEpisode().coverImage=null;
                  this.GS.getStoryEpisode().coverImageURL=null;
                  this.GS.getStoryEpisode().characters=[
                    { id:"角色甲",
                      text: {
                          "color": "#ffffff",
                          "size": "medium",
                          "style": "regular",                
                      },
                      name: {
                          "color": "#ffffff",
                          "size": "medium",
                          "style": "regular"
                      },
                      bubble_color:"#666666"            
                    }         
                ];
                  this.GS.getStoryEpisode().uuid='';
                  this.props.toggleModalState("createEpisode");
                  this.props.toggleModal(true);              
                }}/>
              </span>
              <h2>創作章節</h2>            
            </Col>     
            { 
              this.GS.getUserEpisodeList().storyEpisodeList.content.map((episode,i)=>{
              //console.log(episode.uuid);
              let bookCover;
              if (episode.image.hasOwnProperty('large'))
                bookCover = <img src={episode.image.large} class="img-fluid"/>
              else 
                bookCover = <img src="story.jpg"  class="img-fluid"/>
                
                return (
            <Col md="3">
              <div class="hovereffect p-3">
                {bookCover}
                <h4 className="mt-3">{episode.title}</h4>
                <h5>{episode.sequence}</h5>
                {(global.DEBUG)?episode.uuid:''}

                <div class="overlay">                  
                  <p class="icon-links">
                    
                    <a href="#">
                    <FontAwesomeIcon className={`text-white`}icon={faTrash} title="刪除" uuid={episode.uuid} onClick={()=>{
                        var r = window.confirm("確認刪除?");
                        if (r ===true ) this.connector.deleteStoryEpisode(episode.uuid,()=>{t.forceUpdate();});                                                            
                      }}/>
                    </a>                   
                    <a href="javascript:void(0)">                      
                            <FontAwesomeIcon className={`mr-3 text-white`} icon={faEdit} title="編輯" uuid={episode.uuid} onClick ={()=>{

                              var editStoryEpisode = {
                                project_name: episode.title,
                                author: episode.author,
                                sequence:episode.sequence,                                
                                coverImage:null,
                                coverImageURL:episode.image.large,
                                uuid:episode.uuid,
                                freePreview:episode.freePreview,
                                order:episode.order
                              }
                                this.GS.setStoryEpisode(editStoryEpisode);
                                this.props.toggleModalState("createEpisode",3);
                                this.props.toggleModal(true);              
                                
                                
                                
                              }}/>
                          </a>                   

                    <a href={((global.CMS_URL=='https://tbcstory.com/')?'https://tbcstory.com/':"https://tbcstory.com/")+((this.GS.getStory().channel)?"/channel/":"/story/")+this.GS.getStory().uuid+"/episode/"+episode.uuid}
                    target="_blank">
                    <FontAwesomeIcon className={`mr-3 text-white`}icon={faSearch} title="預覽" onClick={()=>{                        
                      }}/>
                    </a>                   


                  </p>
                </div>                
              </div>
            </Col>
            )})
            }
            
          </Row>
      </Container>
    </div>
    )
  }
}